import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TipoEnvio } from '../../shared/models/system';
import { environment } from '../../../environments/environment.dev';
import { Auth } from './auth.service';

@Injectable({ providedIn: 'root' })
export class TipoEnvioService {
  private apiUrl = `${environment.apiUrl}/tipo-envio`;

  constructor(private http: HttpClient, private auth: Auth) {}

  private getHeaders() {
    const token = this.auth.getToken();
    return {
      headers: new HttpHeaders({ 'Authorization': `Bearer ${token}` })
    };
  }

  getAll(): Observable<TipoEnvio[]> {
    return this.http.get<TipoEnvio[]>(`${this.apiUrl}`, this.getHeaders());
  }

  getActive(): Observable<TipoEnvio[]> {
    return this.http.get<TipoEnvio[]>(`${this.apiUrl}/active`, this.getHeaders());
  }

  create(tipoEnvio: Partial<TipoEnvio>): Observable<TipoEnvio> {
    return this.http.post<TipoEnvio>(`${this.apiUrl}`, tipoEnvio, this.getHeaders());
  }

  update(id: number, tipoEnvio: TipoEnvio): Observable<TipoEnvio> {
    return this.http.put<TipoEnvio>(`${this.apiUrl}/${id}`, tipoEnvio, this.getHeaders());
  }

  toggle(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`, this.getHeaders());
  }
}
